import { useMemo } from 'react';
import { object } from 'yup';
import { useSignUpSchema } from '../../../../../auth/sign-up/ui/form/helpers/useSignUpSchema';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { ICreateUserAccountFormData } from '../types/ICreateUserAccountFormData';

export function useCreateUserAccountSchema() {
	const signUpSchema = useSignUpSchema();
	const { t } = useTranslation();

	return useMemo(
		() =>
			object<ICreateUserAccountFormData>({
				password: signUpSchema.fields.password,
				confirmPassword: signUpSchema.fields.confirmPassword,
			}).required(t('password_form_field_error')),
		[signUpSchema],
	);
}
